<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData">

      <template v-slot:decide="update">
        <div><span>{{$t('other.question.decide')}}</span></div>
        <Question :update="update"></Question>
      </template>

      <template v-slot:radio="update">
        <div><span>{{$t('other.question.radio')}}</span></div>
        <Question :update="update"></Question>
      </template>

      <template v-slot:checkbox="update">
        <div><span>{{$t('other.question.checkbox')}}</span></div>
        <Question :update="update"></Question>
      </template>

    </UPDATE>
  </div>
</template>

<script>
    import Qs from 'qs'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    import Url from "@/views/other/util/url"
    import Question from '@/views/other/question/question.vue'
    import tablePage from '@/components/page/table.vue'
    let codeList = {};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE,
            Question
        },
        mounted(){
            this.$axios.get(Url.question.type.codeList).then(res => {
                if (res.code == 0){
                    for (let i in res.result) {
                        codeList[res.result[i].code] = res.result[i].name;
                    }
                    this.updateData.cols = [
                        { title: 'id', field: 'id',hidden:true},
                        { title: window.$t('other.question.name'), field: 'code',type:2,optionList:codeList},
                        { title: window.$t('other.question.decide'), field: 'decide',question:'decide',type:10,slot:'decide',data:[{}],required:true},
                        { title: window.$t('other.question.radio'), field: 'radio',question:'radio',type:10,slot:'radio',data:[{options:[{}]}],required:true},
                        { title: window.$t('other.question.checkbox'), field: 'checkbox',question:'checkbox',type:10,slot:'checkbox',data:[{options:[{}]}],required:true},
                    ]
                }
            });
        },
        methods: {
          /*查询表单按钮点击事件*/
          formclick(clickName,data){
              if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
                  this.queryData = data;
                  this.$refs.childTable.defaultQueryData(this.queryData);
              }else if(window.$t('txmis.bt.add') == clickName){
                  this.$refs.childUpdate.open();
              }
          },
          bthClick (clickName, row) {
              if (clickName == "update"){
                  row.decide = JSON.parse(row.decide);
                  row.radio = JSON.parse(row.radio);
                  row.checkbox = JSON.parse(row.checkbox);
                  this.$refs.childUpdate.open(row);
              }else if(type == "delete"){
                  this.dataChanage(Url.question.content.delete,{id:row.id},res => {
                      if (res.code == 0){
                          this.$refs.childUpdate.close();
                          this.$message.success("suc");
                      }else{
                          this.$message.error(res.message);
                      }
                  })
              }
          },
          submit(model){
              //根据是否包含id更新还是添加
              //统计试题总数量
              model.count = model.decide.length + model.radio.length + model.checkbox.length;
              model.decide = JSON.stringify(model.decide);
              model.radio = JSON.stringify(model.radio);
              model.checkbox = JSON.stringify(model.checkbox);
              this.dataChanage(Url.question.content.update,model,res => {
                  if (res.code == 0){
                      this.$refs.childUpdate.close();
                      this.$message.success("suc");
                      this.$refs.childTable.defaultQueryData(this.queryData);
                  }else{
                      this.$message.error(res.message);
                  }
              })
          },
          dataChanage(url,option,suc,fail){
              this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                  if(suc && (typeof suc == 'function')) suc(res);
              }).catch(res => {
                  if(fail && (typeof fail == 'function')) fail(res);
              })

          },
        },
        data () {
            return {
                queryData:{},
                typeList:[],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                expandAll:false,
                showCheckbox:false,
                /*from查询表单*/
                formData:{
                    cols:[
                        {click:window.$t('other.bt.search')},
                        {click:window.$t('other.bt.add')},
                    ]
                },
                updateData:{
                    cols:[]
                },
                pageData: {
                    isShow: false,
                    queryUrl: Url.question.content.list, //请求路径和参数
                    sequence: true,
                    cols: [
                        {title:window.$t('other.question.code'), field:'code'},
                        {title:window.$t('other.question.name'), field:'code',render:(data,full)=>{
                            return codeList[full.code];
                            }},
                        {field:window.$t('other.bt.edit'),title:window.$t('other.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-edit"},
                        {field:window.$t('other.bt.delete'),title:window.$t('other.bt.operation'),size:"mini",click:"delete",type:"primary",icon:"el-icon-edit"},
                    ]
                }
            }
        }
    }
</script>
